package diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Immutable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Shape/radii tokens (docs/DESIGN_SYSTEM.md). Access via `AppTheme.shapes`.
 * sm=badges/sponsored · md=buttons/inputs/chips · tile=category icon tiles · card=cards/tiles · xl · pill.
 */
@Immutable
data class AppShapes(
    val sm: RoundedCornerShape = RoundedCornerShape(4.dp),
    val md: RoundedCornerShape = RoundedCornerShape(8.dp),
    val tile: RoundedCornerShape = RoundedCornerShape(12.dp),
    val card: RoundedCornerShape = RoundedCornerShape(16.dp),
    val xl: RoundedCornerShape = RoundedCornerShape(24.dp),
    val xxl: RoundedCornerShape = RoundedCornerShape(32.dp),
    val pill: RoundedCornerShape = RoundedCornerShape(9999.dp),
    // Content sheet sliding under a colored header band (Home): rounded on top only.
    val sheetTop: RoundedCornerShape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp),
    // Chat bubbles (Stitch c8110400): big radius everywhere, small "tail" corner nearest the sender.
    val chatBubbleRadius: Dp = 16.dp,
    val chatBubbleTailRadius: Dp = 4.dp,
)

val appShapes: AppShapes = AppShapes()
